import { render, staticRenderFns } from "./PPMReports.vue?vue&type=template&id=a6e3d81e&scoped=true"
import script from "./PPMReports.vue?vue&type=script&lang=ts"
export * from "./PPMReports.vue?vue&type=script&lang=ts"
import style0 from "./PPMReports.vue?vue&type=style&index=0&id=a6e3d81e&prod&lang=css"
import style1 from "./PPMReports.vue?vue&type=style&index=1&id=a6e3d81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3d81e",
  null
  
)

export default component.exports